import { FEC_REPORT_CONFIRMATION_PARAGRAPH, FEC_REPORT_CONFIRMATION_TITLE } from "shared/pac/constants"

export const ARCHIVE_TRANSACTION_SUCCESS = {
    title: "Archived!",
    text: "Your transaction has been archived.",
    icon: "success",
}

export const ARCHIVE_TRANSACTION_FAILURE = {
    title: "Error",
    text: "There was an issue archiving this transaction.",
    icon: "error",
}

export const CONFIRM_ARCHIVE_TRANSACTION = {
    buttons: ["Cancel", "Yes"],
    title: "Archive Transaction?",
    text: "Are you sure you want to archive this Transaction?",
    icon: "warning",
}

export const VOID_TRANSACTION_SUCCESS = {
    title: "Voided!",
    text: "Your transaction has been voided.",
    icon: "success",
}

export const VOID_TRANSACTION_FAILURE = {
    title: "Error",
    text: "There was an issue voiding this transaction.",
    icon: "error",
}

export const VOID_TRANSACTION_RECEIPT_ERROR = {
    title: "Error",
    text: `A receipt cannot be voided.`,
    icon: "error",
}

export const VOID_TRANSACTION_INPUT_ERROR = {
    title: "Error",
    text: "Please enter a valid description.",
    icon: "error",
}

export const VOID_TRANSACTION_INPUT_ERROR_EMPTY = {
    title: "Error",
    text: "Please enter a valid void description.",
    icon: "error",
}

export const CONFIRM_ARCHIVE_RECONCILIATION = {
    buttons: ["Cancel", "Confirm"],
    title: "Archive Reconciliation?",
    text: "Are you sure you want to archive this Reconciliation?",
    icon: "warning",
}
export const ARCHIVE_RECONCILIATION_SUCCESS = {
    title: "Archived.",
    text: "Reconciliation successfully archived.",
    icon: "success",
}
export const ARCHIVE_RECONCILIATION_FAILURE = {
    title: "Error.",
    text: "There was an error archiving this reconciliation. Please contact support for help.",
    icon: "error",
}

export const CONFIRM_FEC_REPORT_FILE = {
    buttons: ["Cancel", "Yes"],
    title: FEC_REPORT_CONFIRMATION_TITLE,
    text: FEC_REPORT_CONFIRMATION_PARAGRAPH,
    icon: "warning",
}

export const SUBMITTING_FEC_REPORT = {
    title: "Submitting FEC Report...",
    text: "We are submitting your report to the FEC.  It might take a little while, so please check the filings table in a few minutes for the filing status of the report.",
    icon: "info",
}

export const LOADING_FEC_REPORT = {
    title: "Loading FEC Report...",
    text: " ",
    icon: "info",
    buttons: false,
}

export const submitFecReportError = (details) => ({
    title: "Error",
    text: `There was an error submitting the FEC Report. ${details}`,
    icon: "error",
})

export const confirmVoidDate = (datepicker) => ({
    title: "Please provide a description for voiding and a void date",
    content: datepicker,
    buttons: true,
    closeOnClickOutside: false,
})

export const CONFIRM_VOID_DESCRIPTION = {
    title: "Void Description",
    text: "Brief reason why you are voiding",
    content: {
        element: "input",
        attributes: {
            placeholder: "Description of void",
        },
    },
    buttons: {
        cancel: "Cancel",
        confirm: {
            text: "OK",
        },
    },
}

export const CONFIRM_VOID_TRANSACTION = {
    buttons: ["Cancel", "Yes"],
    title: "Void Transaction?",
    text: "Are you sure you want to void this Transaction?",
    icon: "warning",
}

export const UNABLE_TO_LOAD_FORM_ERROR = {
    title: "Error",
    text: "An error occurred trying to load this form. Please refresh the page to try again.",
    icon: "error",
    buttons: ["Refresh"],
}

export const UNABLE_TO_SUBMIT_FORM_ERROR = {
    title: "Error",
    text: "An error occurred trying to submit this form",
    icon: "error",
}

export const DOWNLOADING_STARTED = {
    title: "Downloading...",
    text: " ",
    icon: "info",
    buttons: false,
}

export const DOWNLOADING_SUCCESS = {
    title: "Success!",
    text: "Finished download.",
    icon: "success",
    timer: 1000,
    buttons: false,
}

export const DOWNLOADING_FAILURE = {
    title: "Error",
    text: "There was an error downloading this report.",
    icon: "error",
}

export const NO_ERRORS_OR_WARNINGS = {
    title: "No Errors Or Warnings Found",
    text: "No errors or warnings were found after running FEC Check on this report!",
    icon: "success",
}

export const MISSING_DEFAULT_ACCOUNT_FAILURE = {
    title: "Error",
    text: "A default bank account must be configured before you can print checks.",
    icon: "error",
}

export const ARCHIVE_PACFILE_SUCCESS = {
    title: "Success!",
    text: "The filing has been archived.",
    icon: "success",
}

export const ARCHIVE_PACFILE_FAILURE = {
    title: "Error",
    text: "There was an issue archiving this filing.",
    icon: "error",
}

export const CONFIRM_ARCHIVE_PACFILE = {
    buttons: {
        cancel: true,
        confirm: {
            closeModal: false,
        },
    },
    title: "Archive filing?",
    text: "Are you sure you want to archive this filing? You will not be able to recover it once it has been archived.",
    icon: "warning",
}

export const FILING_STILL_SUBMITTING_LOADING = {
    title: "Loading",
    text: "Please wait\u2026",
    icon: "info",
    allowOutsideClick: false,
    buttons: false,
}

export const customErrorSwal = (error) => ({
    title: "Error",
    text: error,
    icon: "error",
})

export const UNABLE_TO_GET_START_DATE = {
    title: "Error",
    text: "An error occurred trying to load the start date for this filing.",
    icon: "error",
}

export const UNABLE_TO_GET_GENERAL_ELECTION = {
    title: "Error",
    text: "An error occurred trying to load the general election for the current election cycle.",
    icon: "error",
}

export const UNABLE_TO_SAVE_FORM1_HISTORICAL = {
    title: "Error",
    text: "Unable to save historical Form 1 filing",
    icon: "error",
}
